import React, { Component } from "react";
import PropTypes from "prop-types";

import { Alert, Card, CardBody, Col, Container, Row, Label } from "reactstrap";

// Redux
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";

// actions
import { apiError, loginUser } from "../../store/actions";

// import images
import profile from "../../assets/images/logo-cgos-login.png";

class Login extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    this.props.apiError("");
  }

  render() {
    return (
      <React.Fragment>
        <div className="account-pages my-5 pt-sm-5">
          <Container>
            <Row className="justify-content-center">
              <Col md={8} lg={6} xl={5}>
                <Card className="overflow-hidden">
                  <div>
                    <Row>
                      <Col className="col-12">
                      <center><img src={profile} alt="" className="img-fluid mb-2" style={{maxHeight: 65, maxWidth: 460, marginTop: "2%"}}/></center>
                      </Col>
                    </Row>
                  </div>
                  <CardBody className="pt-3">
                    <div className="p-2">
                      {this.props.error && this.props.error ? (
                        <Alert color="danger">{this.props.error}</Alert>
                      ) : null}
                      <Formik
                        enableReinitialize={true}
                        initialValues={{
                          username:'',
                          password:'',
                        }}
                        validationSchema={Yup.object().shape({
                          username: Yup.string().required(
                            "L'identifiant est obligatoire"
                          ),
                          password: Yup.string().required(
                            "Le mot de passe est obligatoire"
                          ),
                        })}
                        onSubmit={values => {
                          this.props.loginUser(values, this.props.history);
                        }}
                      >
                        {({ errors, status, touched }) => (

                          <Form className="form-horizontal">
                            <div className="mb-3">
                              <center>
                                <Label for="username" className="form-label" style={{fontWeight: "bold", textAlign: "center"}}>
                                  Identifiant
                                </Label>
                              </center>
                              <Field
                                name="username"
                                type="text"
                                className={
                                  "form-control" +
                                  (errors.username && touched.username
                                    ? " is-invalid"
                                    : "")
                                }
                              />
                              <ErrorMessage
                                name="username"
                                component="div"
                                className="invalid-feedback"
                              />
                            </div>
                            <div className="mb-3">
                              <center>
                                <Label for="password" className="form-label" style={{fontWeight: "bold", textAlign: "center"}}>
                                  Mot de passe
                                </Label>
                              </center>
                              <div className="input-group auth-pass-inputgroup">
                                <Field
                                  name="password"
                                  type="password"
                                  autoComplete="true"
                                  className={
                                    "form-control" +
                                    (errors.password && touched.password
                                      ? " is-invalid"
                                      : "")
                                  }
                                />
                              </div>
                              <ErrorMessage
                                name="password"
                                component="div"
                                className="invalid-feedback" />
                            </div>

                            <div className="mt-4 mb-5 d-grid">
                              <button className="btn btn-primary btn-block" type="submit">
                                Connexion
                              </button>
                            </div>
                          </Form>
                        )}
                      </Formik>
                    </div>
                  </CardBody>
                </Card>
                <div className="mt-5 text-center">
                  <p>
                    © {new Date().getFullYear()} File Handler Viewer - 1.1.7
                  </p>
                </div>
              </Col>
            </Row>
          </Container>
        </div>
      </React.Fragment>
    );
  }
}

Login.propTypes = {
  apiError: PropTypes.any,
  error: PropTypes.any,
  history: PropTypes.object,
  loginUser: PropTypes.func,
};

const mapStateToProps = state => {
  const { error } = state.Login;
  return { error };
};

export default withRouter(
  connect(mapStateToProps, { loginUser, apiError })(Login)
);
